import { render, staticRenderFns } from "./SingleEmployee.vue?vue&type=template&id=0b22eeea&scoped=true&"
import script from "./SingleEmployee.vue?vue&type=script&lang=js&"
export * from "./SingleEmployee.vue?vue&type=script&lang=js&"
import style0 from "./SingleEmployee.vue?vue&type=style&index=0&id=0b22eeea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b22eeea",
  null
  
)

export default component.exports